import { faEdit, faPlus } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { useFormContext } from "react-hook-form";
import {
    InserirTipoAtividadesController,
    UptadeTipoAtividadesController,
} from "../../../../../../Controllers/Geral/TipoAtividades";
import { ITipoAtividades } from "../../../../../../Interfaces/Geral/TipoAtividades";
import UnForm from "../../../../../Form";
import IconSelector from "../../../../../CardsPages/Forms/IconSelector";
import { ListarModulosController } from "../../../../../../Controllers/Geral/Documentos/DocumentosController";
import useAsyncEffect from "../../../../../../hooks/useAsyncEffect";
import OrSpinner from "../../../../../Utils/OrSpinner";

interface ICreateUpdateTipoAtividadesProps {
    tipoAtividade?: ITipoAtividades;
    onSave?: () => void;
}

export default function CreateUpdateTipoAtividades(
    props: ICreateUpdateTipoAtividadesProps
) {
    const [icon, setIcon] = useState(props.tipoAtividade?.DS_ICONE);

    const { value: lstModulos, loading: lstModulosLoading } = useAsyncEffect(
        () => ListarModulosController(),
        []
    );

    function CreateUpdateTipoAtividadesSubmit(formData: ITipoAtividades) {
        let promise: Promise<ITipoAtividades[]>;
        if (props.tipoAtividade) {
            promise = UptadeTipoAtividadesController({
                ...formData,
                DS_ICONE: icon ?? "",
                ID_TIPO_ATIVIDADE: props.tipoAtividade.ID_TIPO_ATIVIDADE,
            });
        } else {
            promise = InserirTipoAtividadesController({
                ...formData,
                DS_ICONE: icon ?? "",
            });
        }

        promise.then(() => {
            props.onSave?.();
        });
    }

    return (
        <OrSpinner loading={lstModulosLoading} spinner="capys">
            {!props.tipoAtividade && (
                <h5 className="text-center">Cadastre um Tipo de Atividade</h5>
            )}
            <UnForm
                handleSubmit={CreateUpdateTipoAtividadesSubmit}
                className="row"
            >
                <UnForm.Input
                    name="DS_TIPO_ATIVIDADE"
                    wrapperClassName="col-8 my-2"
                    label="Tipo de Atividade"
                    defaultValue={props.tipoAtividade?.DS_TIPO_ATIVIDADE}
                />
                <UnForm.Select
                    name="ID_TIPO_CASO"
                    wrapperClassName="col-4 my-2"
                    defaultValue={props.tipoAtividade?.ID_TIPO_CASO}
                    label="Módulo"
                >
                    <option></option>
                    {lstModulos?.map((modulo) => (
                        <option key={modulo.ID_MODULO} value={modulo.ID_MODULO}>
                            {modulo.DS_MODULO}
                        </option>
                    ))}
                </UnForm.Select>

                <IconSelectorWithFormColor
                    onChange={setIcon}
                    defaultValue={props.tipoAtividade?.DS_ICONE}
                />

                <UnForm.SubmitButton
                    color={props.tipoAtividade ? "primary" : "success"}
                    icon={props.tipoAtividade ? faEdit : faPlus}
                    className="w-100"
                    disabled={!icon}
                >
                    {props.tipoAtividade ? "Editar" : "Cadastrar"}
                </UnForm.SubmitButton>
            </UnForm>
        </OrSpinner>
    );
}

function IconSelectorWithFormColor(
    props: Omit<Parameters<typeof IconSelector>["0"], "color"> & {
        defaultColor?: string;
    }
) {
    const { watch } = useFormContext();
    const colorWatcher = watch("HX_COR_TIPO_ATIVIDADE", props.defaultColor);

    return <IconSelector color={colorWatcher} {...props} />;
}
